import React from 'react';
import Layout from '../../components/Layout';
import Faq from './Faq';

function action() {
  return {
    title: 'FAQ | BestHand',
    description: 'Frequently asked questions about booking home services on BestHand.',
    component: (
      <Layout>
        <Faq />
      </Layout>
    ),
  };
}

export default action;
